(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('RptCompendiumDefaultMessageSearch', RptCompendiumDefaultMessageSearch);

    RptCompendiumDefaultMessageSearch.$inject = ['$resource'];

    function RptCompendiumDefaultMessageSearch($resource) {
        var resourceUrl =  'api/_search/rpt-compendium-default-messages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
